<!--VC status spinners-->
<section *ngIf="webcast.vcSipAddress || webcast.vcMicrosoftTeamsMeetingUrl">
	<initializing-spinner *ngIf="webcast.vcStatus.isInitializing">
	</initializing-spinner>

	<connecting-spinner *ngIf="webcast.vcStatus.isConnecting && webcast.vcSipAddress" [destination]="webcast.vcSipAddress">
	</connecting-spinner>

	<connecting-spinner *ngIf="webcast.vcStatus.isConnecting && webcast.vcMicrosoftTeamsMeetingUrl" [destination]="'Microsoft_Teams' | translate">
		<div [ngClass]="styles.msTeamsConnecting">
			{{ 'Microsoft_Teams_ConnectingToMessage' | translate }}
		</div>
	</connecting-spinner>

	<vb-loading-spinner *ngIf="webcast.vcStatus.isGenerating || webcast.vcStatus.waitingForStream || webcast.vcStatus.isRecording" [block]="true" [iconClass]="'glyphicons wifi_alt'" [msg]="'Media_Recording_Generating' | translate" [msgDisplayBelowSpinner]="true" [size]="'large'">
	</vb-loading-spinner>
</section>

<!--WebrtcSinglePresenter status spinners-->
<section *ngIf="webcast.isWebrtcSinglePresenter">
	<initializing-spinner *ngIf="webcast.vcStatus.isInitializing">
	</initializing-spinner>

	<vb-loading-spinner *ngIf="webrtcSiglePresenterWaitingForStream" [block]="true" [iconClass]="'glyphicons wifi_alt'" [msg]="'Event_Webcast_WaitingForStream' | translate" [msgDisplayBelowSpinner]="true" [size]="'large'">
	</vb-loading-spinner>
</section>

<!--Webex Live Stream-->
<section *ngIf="webcast.isWebexLiveStreamType || webcast.isRtmpStreamType || webcast.isEnrichedPresentationProfile || webcast.isVodSource">
	@if(webcast.vcStatus.loadingSwitchStream) {
		<vb-loading-spinner [block]="true" [iconClass]="'glyphicons wifi_alt'" [msg]="'SwitchingStream' | translate" [msgDisplayBelowSpinner]="true" [size]="'large'">
		</vb-loading-spinner>
	} @else {
		<initializing-spinner *ngIf="webcast.vcStatus.isInitializing; else notInitializing">
		</initializing-spinner>
		<ng-template #notInitializing>
			<vb-loading-spinner *ngIf="webcast.vcStatus.waitingForStream; else noWaitingForStream" [block]="true" [iconClass]="'vb-icon vb-icon-not-streaming'" [msg]="'Event_Webcast_WaitingForStream' | translate" [msgDisplayBelowSpinner]="true" [size]="'large'">
			</vb-loading-spinner>
			<ng-template #noWaitingForStream>
				<vb-loading-spinner *ngIf="webcast.waitingForVideoSource && webcast.vcStatus.isRecording" [block]="true" [iconClass]="'glyphicons wifi_alt'" [msg]="'LoadingStream' | translate" [msgDisplayBelowSpinner]="true" [size]="'large'">
				</vb-loading-spinner>
			</ng-template>
		</ng-template>
	}
</section>
